import { render, staticRenderFns } from "./info.vue?vue&type=template&id=0f3a2315&scoped=true"
import script from "./info.vue?vue&type=script&lang=js"
export * from "./info.vue?vue&type=script&lang=js"
import style0 from "./info.vue?vue&type=style&index=0&id=0f3a2315&scoped=true&lang=scss"
import style1 from "./info.vue?vue&type=style&index=1&id=0f3a2315&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f3a2315",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\git\\platform_el\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0f3a2315')) {
      api.createRecord('0f3a2315', component.options)
    } else {
      api.reload('0f3a2315', component.options)
    }
    module.hot.accept("./info.vue?vue&type=template&id=0f3a2315&scoped=true", function () {
      api.rerender('0f3a2315', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sportManage/users/competition/info.vue"
export default component.exports